import { BrowserRouter, Routes, Route } from "react-router-dom";
import Frame from "./Pages/Frame";
import Intermediary from "./Pages/Intermediary";
import Redirect from "./Pages/Redirect";
import NotFound from "./Pages/NotFound";
import { Provider } from "./Context";

function App() {
  return (
    <Provider>
      <BrowserRouter>
        <Routes>
          <Route path="/:carouselName" element={<Frame />} />
          <Route
            path="/intermediary/:carouselName"
            element={<Intermediary />}
          />
          <Route path="/" element={<Redirect />} />
          <Route path="/redirect" element={<Redirect />} />
          <Route path="/notfound" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
